// EXACT certifications data - Do not modify the statement and list

export const certificationsData = {
  // EXACT heading sentence
  statement:
    "Voitech Solutions is a certified ICT service provider committed to excellence, holding prestigious certifications that demonstrate our expertise:",

  // EXACT list - Do not modify spelling
  certifications: [
    {
      name: "NITA",
      logo: "h/img/certifications/nita.png",
    },
    { name: "SIEMON", logo: "/img/certifications/siemon.png" },
    { name: "MITEL", logo: "/img/certifications/mitel.png" },
    {
      name: "SOPHOS",
      logo: "/img/certifications/sophos.png",
    },

    // DO NOT ALTER (per your instruction)
    {
      name: "HPE",
      logo: "https://upload.wikimedia.org/wikipedia/commons/4/46/Hewlett_Packard_Enterprise_logo.svg",
    },
    // DO NOT ALTER (per your instruction)
    {
      name: "MICROSOFT",
      logo: "https://upload.wikimedia.org/wikipedia/commons/9/96/Microsoft_logo_%282012%29.svg",
    },

    { name: "RUIJIE", logo: "/img/certifications/ruijie.png" },
    { name: "CHECKPOINT", logo: "/img/certifications/checkpoint.png" },
    { name: "ARISTA", logo: "/img/certifications/arista.png" },
    { name: "TELTONIKA", logo: "/img/certifications/teltonika.png" },

    // file in your folder is "baracuda.png" (matches your screenshot)
    { name: "BARACCUDA", logo: "/img/certifications/baracuda.png" },

    { name: "GIGANET", logo: "/img/certifications/giganet.png" },
    { name: "HIK VISION", logo: "/img/certifications/hikvision.png" },
    { name: "VEEAM", logo: "/img/certifications/veeam.png" },
  ],

  // EXACT training sentence
  trainingStatement:
    "Our team undergoes continuous training to stay updated with the latest industry trends and technologies, ensuring that we deliver the most effective and innovative solutions to our clients. With our certified expertise, we strive to provide exceptional service and support to help our clients achieve their goals.",
};
